export default __webpack_public_path__ + "06eb70a2cb2aaae4693b6dc55b894b7b.png";